var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Loader',{attrs:{"isLoading":true}}),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }